import axios from "axios";

//state
export var pixelState = {
  pixel: {},
  pixels: [],
  all_pixels: [],
  status_pixels: ""
};

//getters
export var pixelGetters = {
  //funciones para optener informacion del state
  getPixel: state => state.pixel,
  getPixels: state => state.pixels,
  getAllPixels: state => state.all_pixels,
  getAllPixelsbyPartner: state => state.all_pixels
};
const user_context = JSON.parse(localStorage.getItem('user_context'));
const uid = localStorage.getItem("uid");
const pass = localStorage.getItem("pass");

//actions
export var pixelActions = {
  async getPixels({ commit,state }, id) {
    var access_token = state.api_token_facebook
    commit("pixel_request");
    await axios
      .get(`https://graph.facebook.com/v4.0/${id}/adspixels`, {
        params: {
          fields: "name,code",
          access_token
        }

      })
      .then(res => {
        const pixels = res.data.data;
        commit("pixels_success", pixels);
        return pixels;
      })
      .catch(err => {
        commit("pixel_error");
        return err;
      });
  },
  async getAllPixels({ commit }) {
    //console.log("get pixels :::::", commit);

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [this._vm.$http.defaults.db, uid, pass, 'brand_whisper.review', 'search_read', [], [], 0,10,'' ]
      },
    };

    commit("pixel_request");
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var pixels = res.data.result;
        console.log("pixels_all_success :::: ", res.data.result);
        commit("pixels_all_success", pixels);
        return res;
      })
      .catch(err => {
        commit("pixel_error");
        return err;
      });
  },
  async getAllPixelsbyPartner({ commit }) {//,partner_id
    // //console.log("get pixels :::::", commit);
    
    commit("pixel_request");
    var req_data = {"jsonrpc": "2.0",
                    "method": "call",
                    "params": {
                        service: 'object',
                        method: 'execute',
                        args: [axios.defaults.db, uid, pass, 'apache.pixel', 'search_read', [], ["pixel_code", "id","name"],0,0,""]
                      }
                    }

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then(res => {
        var pixels = [];//res.data;
        if(res.data.result.length > 0){
           pixels =  res.data.result
        }
        //console.log("pixels_all_success :::: ", res.data, pixels);
        commit("pixels_all_success", pixels);
        return res;
      })
      .catch(err => {
        commit("pixel_error");
        return err;
      });
  },
  async newPixel({ commit, state }, pixel) {
    commit("partner_request");
    var { pixel_code, account_ids } = pixel;
    var formData = new FormData();
    var newPixel = `{
      'pixel_code':'${pixel_code}',
      'account_ids':[${account_ids}] ,
      'relational_fields': [('account_ids', 'apache.ad_account')]
    }`;

    formData.append("data", newPixel);
    await this._vm.$http
      .post("/apache/rest_api/apache.pixel", formData, {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
        }
      })
      .then(res => {
        if (res.status == 201) {
          pixel.id = res.data.id;
          var pixels = state.all_pixels;
          pixels.push(pixel);
          commit("pixels_all_success", pixels);
          return pixels;
        } else {
          commit("pixel_error");
        }
      })
      .catch(err => {
        commit("pixel_error");
        return err;
      });
  }
};

//mutations

export var pixelMutations = {
  pixel_request(state) {
    state.status_pixels = "loading";
  },
  pixel_success(state, payload) {
    state.status_pixels = "success";
    state.pixel = payload;
  },
  pixels_success(state, payload) {
    state.status_pixels = "success";
    state.pixels = payload;
  },
  pixels_all_success(state, payload) {
    state.status_pixels = "success";
    state.all_pixels = payload;
  },
  pixel_error(state) {
    state.status_pixels = "error";
  }
};
